import React, { useState, useEffect } from "react";
import { Form, Table, Input, DatePicker, Tooltip } from "antd";
import FormSearchFilter from "../../components/FormSearchFilter";
import APIService from "../../service/APIService";
import _ from "lodash";
import { priceFormat, strUcfirst } from "../../utils";
import moment from "moment";

const { RangePicker } = DatePicker;
const dateFormatPicker = "DD-MM-YYYY";


export default function JackbotFishLogPage() {
  const [dataTable, setDataTable] = useState([]);
  const [filter, setFilter] = useState({
    player: "",
    timeFrom: "",
    timeTo: "",
  });

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width:80,
      align: "center",
    },
    {
      title: "GAME",
      dataIndex: "game",
      key: "game",
      width:120,

    },
    {
      title: "PHÒNG",
      dataIndex: "roomId",
      key: "roomId",
      align: "center",
      width:100,
    },
    {
      title: "MONEY DEFAULT",
      dataIndex: "moneyDefault",
      key: "moneyDefault",
      width:160,
      render: (data) => priceFormat(data),

    },
    {
      title: "perMoneyWinFishNormal",
      dataIndex: "perMoneyWinFishNormal",
      key: "perMoneyWinFishNormal",
      width:220,
      align: "center",
    },
    {
      title: "perMoneyAddToFish",
      dataIndex: "perMoneyAddToFish",
      key: "perMoneyAddToFish",
      width:200,
      align: "center",
    },
    {
      title: "perMoneyAddToPool",
      dataIndex: "perMoneyAddToPool",
      key: "perMoneyAddToPool",
      align: "center",
      width:200,
    },
    {
      title: "perWin2PerDay",
      dataIndex: "perWin2PerDay",
      key: "perWin2PerDay",
      align: "center",
      width:160,
    },
    {
      title: "numMoneyPerSecond",
      dataIndex: "numMoneyPerSecond",
      key: "numMoneyPerSecond",
      align: "center",
      width:200,
    },
    {
      title: "minGunCanHit",
      dataIndex: "minGunCanHit",
      key: "minGunCanHit",
      align: "center",
      width:160,
    },

    {
      title: "status",
      dataIndex: "status",
      key: "status",
      align: "center",
      width:100,
    },
    {
      title: "currentMoneyAddToFish",
      dataIndex: "currentMoneyAddToFish",
      key: "currentMoneyAddToFish",

      render: (data) => priceFormat(data),
      width:220,
    },
    {
      title: "currentMoneyAddToPool",
      dataIndex: "currentMoneyAddToPool",
      key: "currentMoneyAddToPool",

      render: (data) => priceFormat(data),
      width:230,
    },
    {
      title: "TIME START",
      dataIndex: "timeStart",
      key: "timeStart",
      align: "center",
      width: 140,
      render: (data, data1, index) => (
        <p>{moment(data).format('DD-MM-YYYY hh:mm:ss')}</p>
      ),
    },
    {
      title: "TIME END",
      dataIndex: "timeEnd",
      key: "timeEnd",
      align: "center",
      width: 140,
      render: (data, data1, index) => (
        <p>{moment(data).format('DD-MM-YYYY hh:mm:ss')}</p>
      ),
    },
    {
      title: "userIdSkill",
      dataIndex: "userIdSkill",
      key: "userIdSkill",
      align: "center",
      width:140,
    },
    {
      title: "userGunSkill",
      dataIndex: "userGunSkill",
      key: "userGunSkill",
      render: (data) => priceFormat(data),
      width:140,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: 140,
      render: (data, data1, index) => (
        <p>{moment(data).format('DD-MM-YYYY hh:mm:ss')}</p>
      ),
    },
  ];

  async function getJackpotFishLog() {
    try {
      const data = await APIService.jackpotFishLog(
        filter.player,
        filter.timeFrom,
        filter.timeTo
      );
      if (data) {
        setDataTable(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getJackpotFishLog();
  }, [filter]);

  return (
    <>
      <FormSearchFilter
      title="Jackpot Fish Log"
        initialValues={filter}
        onFormLayoutChange={(value) => {
          console.log(value);
          if (value.time) {
            setFilter({
              ...filter,
              timeFrom: moment(value.time[0]).format('YYYY-MM-DD'),
              timeTo: moment(value.time[1]).format('YYYY-MM-DD'),
            });
          } else {
            setFilter({ ...filter, ...value });
          }
        }}
      >
        <Form.Item label="User ID" className="form-item-filter" name="player">
          <Input className="w-full" />
        </Form.Item>
        <Form.Item label="Time" className="form-datepicker-filter" name="time">
          <RangePicker format={dateFormatPicker} />
        </Form.Item>
      </FormSearchFilter>

      <Table columns={columns} dataSource={dataTable} />
    </>
  );
}
